import { COLORS } from 'helpers/globals'

export default {
  errorMessage: {
    marginBottom: '2rem',
    border: '1px solid red',
    padding: '.5rem',
    background: '#ffdbdb'
  },
  projectsTable: {
    margin: 0,
    '& tr': {
      '&:last-of-type': {
        '& td': { border: 0 }
      }
    },
    '& th': {
      paddingBottom: '.5rem',
      paddingLeft: 0,
      '&:nth-of-type(1)': {
        width: '50%'
      },
      '&:nth-of-type(2)': {
        width: '20%'
      },
      '&:nth-of-type(3)': {
        width: '20%'
      },
      '&:nth-of-type(4)': {
        width: '10%'
      }
    },
    '& td': {
      paddingLeft: 0,
      '&:nth-of-type(1)': {
        width: '50%'
      },
      '&:nth-of-type(2)': {
        width: '20%'
      },
      '&:nth-of-type(3)': {
        width: '20%'
      },
      '&:nth-of-type(4)': {
        width: '10%'
      }
    }
  },
  scrollTable: {
    height: 215,
    overflowY: 'auto'
  },
  openProjectEnabled: {
    color: COLORS.primary,
    cursor: 'pointer',
    '&:hover': {
      color: COLORS.secondary
    }
  },
  openProjectDisabled: {
    color: `lighten(${COLORS.primary}, 25%)`,
    cursor: 'not-allowed'
  },
  removeProject: {
    width: 80,
    textAlign: 'center',
    paddingLeft: 0,
    cursor: 'pointer',
    fontSize: '2rem',
    color: 'red'
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectList/style.js